import ForbiddenPage from '@modules/error/Forbidden';
import NotFoundPage from '@modules/error/NotFound';
import LoginPage from '@modules/login/index';
import ProfilePage from '@modules/profile/index';
import adminRoutes from '@modules/user/routes';
import logRoutes from '@modules/logs/routes';

/*
	auth
		+ null: access login and not login
		+ true: access login only
		+ false: access not login only
*/

// Phạm vi (MIGRATION.md): 2 trang đang bật trên menu + trang phụ trợ bắt buộc.
// Module chưa port thì CHƯA khai ở đây:
//
// ⚠️ ra-log-monitor KHÔNG có trang /auth (không dùng 2FA TOTP) — đăng nhập 2 bước bằng OTP
//    qua requestToken, xử lý ngay trong trang /login.

const routes = {
    forbiddenPage: {
        path: '/forbidden',
        component: ForbiddenPage,
        auth: true,
        title: 'Forbidden page',
    },
    loginPage: {
        path: '/login',
        component: LoginPage,
        auth: false,
        title: 'Login page',
    },
    profilePage: {
        path: '/profile',
        component: ProfilePage,
        auth: true,
        title: 'Profile page',
    },
    ...adminRoutes,
    ...logRoutes,
    // keep this at last
    notFound: {
        component: NotFoundPage,
        auth: null,
        title: 'Page not found',
        path: '*',
    },
};

export default routes;
